module.exports = __webpack_public_path__ + "img/buddy_ears-02.3dfcd9e5.svg";